import {regexes} from "../helpers/regexes";
import {asyncResolve} from "./common"
export const getHeadersAsync = async function getHeadersAsync(){
    const headerBlock = await getHeaderBlockAsync();
    const headers = parseHeaders(headerBlock);
    return headers;
  }


export const getEmailLoggingInfo = function getEmailLoggingInfo(){
    return {
      emailClientMessageId: Office.context.mailbox.item.itemId,
      messageId: Office.context.mailbox.item.internetMessageId,
      subject: Office.context.mailbox.item.normalizedSubject,
      sender: Office.context.mailbox.item.sender,
      from: Office.context.mailbox.item.from,
      to: Office.context.mailbox.item.to,
      deliveredTo: Office.context.mailbox.userProfile
    }
  }


export const getEmailDetails = function getEmailDetails(){
    return {
        "origDate": Office.context.mailbox.item.dateTimeCreated,
        "from": Office.context.mailbox.item.from,
        "sender": Office.context.mailbox.item.sender
    }
}

export const getUserProfile = function getUserProfile(){
  return Office.context.mailbox.userProfile;
}

/**
  * Creates a promise with the outlook function, 'getAllInternetHeadersAsync'
  * awaits the promise, which returns a string of all internet headers for the current email context
  * @returns {String}
  */
const getHeaderBlockAsync = async function getHeaderBlockAsync(){
    // Get the internet headers related to the mail.
    const headerBlock = await new Promise((resolve) => {
      Office.context.mailbox.item.getAllInternetHeadersAsync((asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
          // console.log(asyncResult.value);
          // Return string of header block
          resolve(asyncResult.value.trim());
        } 
        else {
            if (asyncResult.error.code == 9020) {
                // GenericResponseError returned when there is no context.
                // Treat as no context.
                resolve("");
            } 
            else {
                // Handle the error.
                resolve("");
            }
        }
      })
    });
    return headerBlock;
  }

/**
* Accepts a string of the email headers
* Returns an object with each parsed header property
* @param {String} headerBlock string of the email headers
* @returns {Object}
*/
const parseHeaders = function parseHeaders(headerBlock){
    const headers = {};
    let headerName = "";
    headerBlock.split(regexes.newLine).forEach(function(line) {
      const leadingWhiteSpaceCount = line.search(regexes.leadingWhiteSpace);
      if(leadingWhiteSpaceCount > 0){
        const headerValue = line.substring(leadingWhiteSpaceCount).trim();
        // If the new line begins with whitespace, then it is still part of the
        // same header property.
        if(Array.isArray(headers[headerName])){
          // If the header we want to add to is part of an array
          // grab the last value of the array and append the headerValue
          const arr = headers[headerName];
          arr[arr.length - 1] += " " + headerValue;
        }
        else{
          // The header is just a string, so append to the string.
          headers[headerName] += " " + headerValue;
        }
      }
      else{
        // Add next header property
        const colonIndex = line.indexOf(":");
        if(colonIndex != -1){
          headerName = line.substring(0,colonIndex);
          const headerValue = line.substring(colonIndex + 1).trim();
          
          // If the header property already exists
          if(headers[headerName] !== undefined){
            // There is more than one header for the given header name
            if(Array.isArray(headers[headerName])){
              // Push to array if an array has already been created for the prop
              headers[headerName].push(headerValue);
            }
            else{
              // Create array and add existing string value and new value
              headers[headerName] = new Array(headers[headerName], headerValue);
            }
          }
          else{
            // Add new prop with string value
            headers[headerName] = headerValue;
          }
        }
        else{
          console.log("Something unexpected happened with the header parsing");
        }
      }
    });
    return headers;
  }

  /**
* Creates a promise with the outlook function, 'body.getAsync'
* awaits the promise, which returns a string of the html body
* @returns {String}
*/
export const getHtmlBodyAsync = async function getHtmlBodyAsync(){
  // Get the internet headers related to the mail.
  const promise = await new Promise((resolve) => {
    Office.context.mailbox.item.body.getAsync("html", (asyncResult) => asyncResolve(asyncResult, resolve))
  });
  return promise;
}
